import { OrderComment } from '../../api/ShopClientsAPI';
import { CommissionComment } from '../../api/ComissionContractsAPI';

type Props = {
    comment: OrderComment | CommissionComment;
    type?: 'order' | 'commission';
    isSelf?: boolean;
}

const CommentCard = ({ comment, type = 'order', isSelf = false }: Props) => {
    const isOrderComment = type === 'order';
    const orderComment = isOrderComment ? comment as OrderComment : null;
    const commissionComment = !isOrderComment ? comment as CommissionComment : null;

    const text = isOrderComment ? orderComment?.comment : commissionComment?.comment;
    const creationTime = isOrderComment ? orderComment?.creationTime : commissionComment?.creationTime;
    const author = isOrderComment ? orderComment?.shopName : commissionComment?.writtenBy;

    const sideBarColor = isSelf ? 'border-gold-500' : 'border-gold-600';
    const formattedDate = new Date(creationTime!).toLocaleString();

    return (
        <div className={`bg-white shadow rounded-lg p-4 animate-fade-in-up relative border-l-4 ${sideBarColor}`}>
            {/* <div className={`${sideBarColor} w-1 h-full absolute left-0 top-0 rounded-l-lg`}></div> */}
            <div className="flex justify-between items-center mb-2">
                <h4 className="text-lg font-semibold">{author}</h4>
                <span className="text-sm text-gray-600">{formattedDate}</span>
            </div>
            <p className="text-base text-gray-800">{text}</p>
        </div>
    );
};

export default CommentCard;
